<script setup>
/**
 * <kt-select>
 * 
 * TODO - update to use kt-input / kt-autocomplete and native select when mobile ...
 * 
 */

import { ref, computed, watch, useSlots } from "vue";
import ui from "@/services/Api";

const model = defineModel();
const slots = useSlots();

const props = defineProps ({
    id: {
        type: String,
        default(props) {
            return "kselect-" + Math.random().toString(36).substring(7);
        }
    },
    type: {
        type: String,
        default: "select"
    },
    inputClass: {
        type: String,
        default: "",
    },
    labelClass: {
        type: String,
        default: ""
    },
    col: {
        type: String,
        default: ""
    },
    label: {
        type: String,
        default: "",
    },
    options: {
        type: Array,
        default: [],
    },
    labelKey: {
        type: String,
        default: "label"
    },
    labelCallback: {
        type: Function,
        default:  undefined
    },
    valueKey: {
        type: String,
        default: "value"
    },
    prefix: String,
    suffix: String,
    suffixClass: String,
    wrapClass: String,
    placeholder: String,
    disabled: {
        type: Boolean
    },
    clear: {
        type: Boolean
    }, 
    multiple: {
        type: Boolean
    },
    limit: {
        type: Number,
        default: 0
    }
});

const emit = defineEmits([
    "blur",
    "focus",
    "clear",
    "change",
]);

const clear = () =>
{
    emit("clear", model.value);
    model.value = "";
};


const limit = (val) =>
{
    
    if (props.limit && val) {
        props.limit = Number(props.limit);
        let ret = (val + "").substring(0, props.limit);
        if (ret.length < val.length) {
            ret += "...";
        }
        return ret;
    }

    return val;
};

const getType = (val) =>
{

};

</script>

<template>

<div :class="['kselect-wrap row', props.wrapClass]">
    <label 
        v-if="props.label || slots.label" 
        :for="props.id"
        :class="['form-label my-auto', props.labelClass]"
    >
        <span v-html="props.label"></span>
        <slot name="label"></slot>
    </label>

    <div 
        :class="props.col"    
    >
        <div class="input-group">
            <!-- Prefix Text -->
            <div 
                v-if="props.prefix || slots.prefix" 
                class="input-group-text"
            >
                <slot name="prefix"></slot>
                <span v-html="props.prefix"></span>
            </div>
            
            <!-- NATIVE SELECT --->
             
            
            <select
                v-if="!props.type || props.type == 'select'"
                v-model="model"
                :id="props.id"
                :class="['kselect form-control form-control-sm', {'border-end-0': props.clear }, inputClass]"
                :disabled="props.disabled"
                @blur="$emit('blur')"
                @focus="$emit('focus')"
                @change="$emit('change')"
                :multiple="props.multiple"
            >
                <!-- Default Selections ... Should Handle All Empty Values ... -->

                <option v-if="!props.placeholder && model === null" :value="null">Choose an option.</option>
                <option v-if="!props.placeholder && model === undefined" :value="undefined">Choose an option.</option>
                <option v-if="!props.placeholder && model === 0" :value="0">Choose an option.</option>
                <option v-if="!props.placeholder && model !== undefined && model !== null && model !== 0" value="">Choose an option.</option>

                <option v-if="props.placeholder && model === null" :value="null">{{ props.placeholder }}</option>
                <option v-if="props.placeholder && model === undefined" :value="undefined">{{ props.placeholder }}</option>
                <option v-if="props.placeholder && model === 0" value="0">{{ props.placeholder }}</option>
                <option v-if="props.placeholder && model !== undefined && model !== null && model !== 0" value="">{{ props.placeholder }}</option>
                
                <!-- Real Options ...-->
                <option v-for="row in props.options" :value="row[props.valueKey]">
                    {{ limit(props.labelCallback ? props.labelCallback(row) : row[props.labelKey]) }}
                </option>
            </select>

            <!-- ? do we want a clear button ?
            <button 
                v-if="props.clear"
                class="btn bg-transparent border-0 border-bottom"
                @click="clear()"
            >
                <span>&times;</span>
            </button>
            -->

            <!-- Suffix Text -->
            <div 
                v-if="props.suffix || slots.suffix" 
                class="input-group-text"
                :class="props.suffixClass"
            >
                <slot name="suffix"></slot>
                <span v-html="props.suffix"></span>
            </div>
        </div>
    </div>
</div>

</template>

<style scoped>

/*
 * Additional CSS Styles ...
 */


</style>